// Section 4: one turn is one season, four per year starting in Spring. Report turn t (1-based,
// the season just resolved) falls in year floor((t - 1) / 4) + 1.
import { catalog, type Season } from '../sim/api';

export const SEASON_ORDER: readonly Season[] = ['spring', 'summer', 'autumn', 'winter'];

export interface SeasonStamp {
  turn: number;
  year: number;
  season: Season;
}

/** The season a report turn (or a memory entry's turn) belongs to. */
export function stampOfTurn(turn: number): SeasonStamp {
  const perYear = catalog().seasonsPerYear;
  const index = Math.max(0, turn - 1);
  return {
    turn,
    year: Math.floor(index / perYear) + 1,
    season: SEASON_ORDER[index % perYear] ?? 'spring',
  };
}
